import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en: {
    translation: {
      choose_language: "Choose Your Language",
      save: "Save",
      spanish: "Spanish",
      french: "French",
      english: "English",
      japanese: "Japanese",
      korean: "Korean",
      chinese: "Chinese",
      ukrainian: "Ukrainian",
      german: "German",
      russian: "Russian",
    },
  },
  es: {
    translation: {
      choose_language: "Elige tu idioma",
      save: "Guardar",
      spanish: "Español",
      french: "Francés",
      english: "Inglés",
      japanese: "Japonés",
      korean: "Coreano",
      chinese: "Chino",
      ukrainian: "Ucraniano",
      german: "Alemán",
      russian: "Ruso",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
